

<div class="flex flex-col items-center justify-center h-screen gap-4">
  @if (redirectCommands()) {
    <button mat-flat-button color="primary" (click)="openInNewTab()">Open in new tab</button>
  } @else {
    <fa-icon icon="circle-notch" animation='spin' size="3x"></fa-icon>
  }
</div>
